import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sameYear',
  standalone: true
})
export class SameYearPipe implements PipeTransform {

  transform(value: string, ...args: unknown[]): unknown {
    const dates: string[] = value.split(' - '); 
    const shipBegin = dates[0];
    const shipEnd = dates[1];
    // console.log('begin', shipBegin);
    // console.log('end', shipEnd)
    if(shipBegin.split(', ')[1] === shipEnd.split(', ')[1]){
      return `${shipBegin.split(', ')[0]} - ${shipEnd}`
    }
    return value;
  }

}
